import React from 'react'
import { Svg, Path } from 'react-native-svg'

interface CreditCardIconProps {
  width?: number
  height?: number
  color?: string
}

export function CreditCardIcon({ width = 32, height = 32 }: CreditCardIconProps) {
  return (
    <Svg width={width} height={height} viewBox="0 0 32 32" fill="none">
      <Path
        d="M5.3335 12.3333C4.78121 12.3333 4.3335 12.781 4.3335 13.3333C4.3335 13.8856 4.78121 14.3333 5.3335 14.3333V12.3333ZM9.3335 9H22.6668V7H9.3335V9ZM25.6668 12V20H27.6668V12H25.6668ZM22.6668 23H9.3335V25H22.6668V23ZM6.3335 20V12H4.3335V20H6.3335ZM9.3335 23C7.67664 23 6.3335 21.6569 6.3335 20H4.3335C4.3335 22.7614 6.57207 25 9.3335 25V23ZM25.6668 20C25.6668 21.6569 24.3237 23 22.6668 23V25C25.4283 25 27.6668 22.7614 27.6668 20H25.6668ZM22.6668 9C24.3237 9 25.6668 10.3431 25.6668 12H27.6668C27.6668 9.23858 25.4283 7 22.6668 7V9ZM9.3335 7C6.57207 7 4.3335 9.23858 4.3335 12H6.3335C6.3335 10.3431 7.67664 9 9.3335 9V7ZM5.3335 14.3333H26.6668V12.3333H5.3335V14.3333ZM20.3335 18.6667C20.3335 18.4826 20.4827 18.3333 20.6668 18.3333V20.3333C21.5873 20.3333 22.3335 19.5871 22.3335 18.6667H20.3335ZM20.6668 18.3333C20.8509 18.3333 21.0002 18.4826 21.0002 18.6667H19.0002C19.0002 19.5871 19.7464 20.3333 20.6668 20.3333V18.3333ZM21.0002 18.6667C21.0002 18.8508 20.8509 19 20.6668 19V17C19.7464 17 19.0002 17.7462 19.0002 18.6667H21.0002ZM20.6668 19C20.4827 19 20.3335 18.8508 20.3335 18.6667H22.3335C22.3335 17.7462 21.5873 17 20.6668 17V19Z"
        fill="white"
      />
    </Svg>
  )
}
